import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
  useRef
} from "react";
import { useSelector, useDispatch } from 'react-redux'
import Joyride, {
  EVENTS,
  ACTIONS,
  STATUS,
} from "react-joyride";

// import CustomTooltip from "./CustomTooltip"; // your tooltip with dots + X
import { TOUR_STEPS } from "../components/JoyRideWalkMe/TourSteps";   // global steps definition
import { waitForElement } from "../components/JoyRideWalkMe/waitForElement";
import { Button, Modal } from "pepsico-ds";
import { CancelWalkmeAccessAction } from "../redux/action/NpsAction";

 const styles = {
  tooltip: {
    minWidth: 320,        // 👈 prevents too small tooltip
    width: 'auto',
    maxWidth: '90vw',
    padding: 20,
    borderRadius: 10,
    background: '#fff',
    boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
    position: 'relative', // 👈 ADD THIS
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10,
  },
  content: {
    fontSize: 14,
    color: '#444',
    marginBottom: 16,
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 6,
    marginBottom: 12,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  stepText: {
    fontSize: 12,
    color: '#888',
  },
  btn: {
    padding: '6px 12px',
    borderRadius: 17,
    border: '1px solid #ccc',
    background: '#fff',
    cursor: 'pointer',
  },
  btnPrimary: {
    padding: '6px 12px',
    borderRadius: 17,
    border: 'none',
    background: '#004895',
    color: '#fff',
    cursor: 'pointer',
  },
  closeBtn: {
  position: 'absolute',
  top: 17,
  right: 15,
  border: 'none',
  background: 'transparent',
  fontSize: 16,
  cursor: 'pointer',
  color: '#2D2D2D',
  fontWeight: 'bold'
},
};


const TourContext = createContext(null);

export const useTour = () => useContext(TourContext);

export const JoyrideProvider = ({ children, onRouteChange }) => {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [showExitWalkme, setShowExitWalkme] = useState(false)
  const [showAnimateRocketBtn, setShowAnimateRocketBtn] = useState(false)
  const [pendingStep, setPendingStep] = useState(null);

  const dispatch = useDispatch()

  const userData = useSelector((state) => state.getLandingPageReducer);

  const userEmailID = useSelector((state) => state.localData.data.userEmailID);

  // const hasStartedRef = useRef(false);

  const CustomTooltip = ({
  index,
  size,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
}) => {
  const [dontShow, setDontShow] = React.useState(false);
  if(localStorage.getItem("hideTour") === null){
    localStorage.setItem('hideTour', 'true');
  }
  /* istanbul ignore next */
  const handleGetStarted = (e) => {
    
    // if (dontShow) {
      localStorage.setItem('hideTour', 'true');
    // }

    primaryProps.onClick(e); //  move to next step
  };

  return (
    <div {...tooltipProps} style={styles.tooltip}>
      {/* Close Button */}
      <button
        {...skipProps}
        aria-label="Close tour"
        style={styles.closeBtn}
        // onClick={()=> setShowExitWalkme(true)}
      >
        ✕
      </button>

      {/* Content */}
      <div style={styles.content}>
        {step.content}
      </div>

      {/* STEP 1 CUSTOM FOOTER */}
      {index === 0 ? (
        <div style={{ marginTop: 20,display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }} className="onboarding-subtext-welcome">
            {/* <input
              type="checkbox"
              // checked={dontShow}
              style={{
                border: "2px solid #2D2D2D",
                transform: "scale(1.25)",  // increase size
                cursor: "pointer"
              }}
              onChange={(e) => {
                setTimeout(() => {
                  setRun(false)
                  setShowAnimateRocketBtn(!showAnimateRocketBtn)
                }, 500);
              }}
            /> */}
              {/* Don't show this again */}
          </label>
          <span className="walkme-step-count" style={{position: 'relative', left: '4rem'}}>
            {index + 1} of {size}
          </span>

          <div style={{ textAlign: 'right'}}>
            <button
              onClick={handleGetStarted}
              style={styles.btnPrimary}
              className="walkme-getstarted-btn"
            >
              <span className="onboarding-forward-btn">Get Started →</span>
            </button>
          </div>
        </div>
      ) : (
        /*  NORMAL FOOTER FOR OTHER STEPS */
        <div style={styles.footer}>
          <button
            {...backProps}
            className="walkme-previous-btn"
            disabled={index === 0}
            // style={styles.btn}
            // text="Previous"
            // iconLeading="50000000:8"
            // size="medium"
            // onClick={() => {}}
          >
            &lt;- Previous
          </button>

          {/* <span style={styles.stepText}> */}
          <span className="walkme-step-count">
            {index + 1} of {size}
          </span>

          {/* <Button {...primaryProps} style={styles.btnPrimary}> */}
          <button {...primaryProps} style={styles.btnPrimary} className="onboarding-forward-btn"  
          >
            {index + 1 === size ? 'Finish' : 'Next ->'}
          </button>
        </div>
      )}
    </div>
  );
  };

  /* istanbul ignore next */
  useEffect(()=>{
    if(sessionStorage.getItem("showLoginAnimation") == "true"){
    // if(showAnimateRocketBtn){
        const element = document.querySelector('.rocket-wrapper');
        
        if (element) {
          element.classList.add('animate-blue');

          element.addEventListener('animationend', () => {
            element.classList.remove('animate-blue');
          }, { once: true });

          sessionStorage.removeItem("showLoginAnimation");
        }
    }
    
  },[showAnimateRocketBtn])
//   /* istanbul ignore next */
//   useEffect(() => {
    
//   if (!run) return;

//   // const stopPropagation = (e) => {
//   //   // Allow clicks inside spotlight only
//   //   const spotlight = document.querySelector('.react-joyride__spotlight');

//   //   if (spotlight && spotlight.contains(e.target)) {
//   //     return; // allow inside spotlight
//   //   }

//   //   e.stopPropagation();
//   // };
//   /* istanbul ignore next */
//   const stopPropagation = (e) => {
//   const tooltip = document.querySelector('.react-joyride__tooltip');
//   const spotlight = document.querySelector('.react-joyride__spotlight');

//   if (
//     (tooltip && tooltip.contains(e.target)) ||
//     (spotlight && spotlight.contains(e.target))
//   ) {
//     return;
//   }

//   e.stopPropagation();
// };
//   document.addEventListener('mousedown', stopPropagation, true);

//   return () => {
//     document.removeEventListener('mousedown', stopPropagation, true);
//   };
// }, [run]);

useEffect(() => {
  if (!run) return;

  const step = TOUR_STEPS[stepIndex];

  // only block clicks for steps that need it
  if (!step?.disableOutsideClick) return;

  // const stopPropagation = (e) => {
  //   const tooltip = document.querySelector('.react-joyride__tooltip');
  //   const spotlight = document.querySelector('.react-joyride__spotlight');

  //   if (
  //     (tooltip && tooltip.contains(e.target)) ||
  //     (spotlight && spotlight.contains(e.target))
  //   ) {
  //     return;
  //   }

  //   e.stopPropagation();
  // };

  const stopPropagation = (e) => {
    const tooltip = document.querySelector('.react-joyride__tooltip');
    const spotlight = document.querySelector('.react-joyride__spotlight');
    const overlay = document.querySelector('.react-joyride__overlay');

    // allow tooltip
    if (tooltip && tooltip.contains(e.target)) return;

    // allow spotlight interaction
    if (spotlight && spotlight.contains(e.target)) return;

    // allow overlay click (needed for outside click detection)
    if (overlay && overlay.contains(e.target)) return;

    e.stopPropagation();
  };
  document.addEventListener('mousedown', stopPropagation, true);

  return () => {
    document.removeEventListener('mousedown', stopPropagation, true);
  };
}, [run, stepIndex]);

 

  // ------------------------------------------------
  // Start / Resume tour
  // ------------------------------------------------
  /* istanbul ignore next */
  useEffect(() => {
    const blockOutsideClick = (e) => {
      // if (e.target.innerText !== "<- Previous" && !window.__JOYRIDESTEP__) return;
      // setTimeout(() => {
        // console.log("stepIndex: ", stepIndex)
        // console.log("run: ", run)
          if ((stepIndex == 4 && (e.target.innerText == "<- Previous" || e.target.innerText == "Next ->"))  || !window.__JOYRIDESTEP__) return;
          // if (!window.__JOYRIDESTEP__) return;
          const dropdown = document.querySelector('.profile-dropdown');

          // allow clicks inside dropdown
          if (dropdown && dropdown.contains(e.target)) return;

          e.stopImmediatePropagation(); // stronger than stopPropagation
          e.preventDefault();
      // }, [50]);
      
    };

    document.addEventListener('pointerdown', blockOutsideClick, true); // capture phase

    return () => {
      document.removeEventListener('pointerdown', blockOutsideClick, true);
    };
  }, [stepIndex]);

  //  useEffect(() => {
  //   const shouldAnimate = sessionStorage.getItem("showLoginAnimation");
  //   if (shouldAnimate !== "true") return;

  //   const observer = new MutationObserver(() => {
  //     const element = document.querySelector(".rocket-wrapper");

  //     if (element) {
  //       element.classList.add("animate-blue");

  //       element.addEventListener(
  //         "animationend",
  //         () => {
  //           element.classList.remove("animate-blue");
  //         },
  //         { once: true }
  //       );

  //       sessionStorage.removeItem("showLoginAnimation");
  //       observer.disconnect();
  //     }
  //   });

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true,
  //   });

  //   return () => observer.disconnect();
  // }, []);
  /* istanbul ignore next */
  const startTour = useCallback(async (startAt = 0) => {
    console.trace("startTour called");
    setRun(false);

    const step = TOUR_STEPS[startAt];

    if (step?.route && onRouteChange) {
      onRouteChange(step.route);
    }

    try {
      await waitForElement(step.target, 5000);
    } catch (err) {
      console.warn("Target not found");
    }

    setStepIndex(startAt);
    setRun(true);

  }, [onRouteChange]);
  // ------------------------------------------------
  // Stop tour
  // ------------------------------------------------
  /* istanbul ignore next */
  const stopTour = useCallback(() => {
    setRun(false);
  }, []);

  /* istanbul ignore next */
  const handleJoyrideCallback = async (data) => {
  const { action, index, type, status } = data;
  // --------------------------------------------------
  // 1️⃣ STOP TOUR
  // --------------------------------------------------

  // allow dropdown to close when navigating steps
  if (action === ACTIONS.NEXT || action === ACTIONS.PREV) {
    window.__JOYRIDESTEP__ = false;
  }
    
  if(action === ACTIONS.NEXT && index === TOUR_STEPS.length-1){
    setRun(false)
    setStepIndex(0)
    if(userData?.isWalkMeEnabled){
        let payload = {
          "emailId" : userEmailID
        }
        dispatch(CancelWalkmeAccessAction(payload))
    }
    const closeBtnModal = document.querySelector('.spend-modal .base-button button');
    if (!closeBtnModal) console.error('closeBtnModal not found');
    if(closeBtnModal) closeBtnModal.click()
    return
  }

  if (action === ACTIONS.CLOSE) {
    setRun(false); // stop tour
    setPendingStep({
      step: TOUR_STEPS[index],
      index
    });         
    setShowExitWalkme(true);   // show your custom modal
    return;
  }

  if (status === STATUS.SKIPPED) {
    // setRun(false);
    window.__JOYRIDESTEP__ = false;
    setShowExitWalkme(true);
    setPendingStep({
      step: TOUR_STEPS[index],
      index
    });
    // setStepIndex(0);
    return;
  }
  
  if (status === STATUS.FINISHED) {
    window.__JOYRIDESTEP__ = false;
    setRun(false);
    // setShowExitWalkme(true);
    setStepIndex(0);
    return;
  }

  // We only care about STEP_AFTER in controlled mode

  if (type !== EVENTS.STEP_AFTER) return;

  // --------------------------------------------------
  // 2️⃣ DETERMINE NEXT INDEX (NEXT or BACK)
  // --------------------------------------------------
  let nextIndex;

  if (action === ACTIONS.PREV) {
    nextIndex = index - 1;
     window.__JOYRIDESTEP__ = false;
  } else if (action === ACTIONS.NEXT) {
    nextIndex = index + 1;
     window.__JOYRIDESTEP__ = false;
  } else {
    return;
  }

  const nextStep = TOUR_STEPS[nextIndex];

  if (nextStep.autoOpenProfileSection || nextStep.autoOpenKpiButton || nextStep.autoOpenDownloadOptions) {
    window.__JOYRIDESTEP__ = true;
  } else {
    window.__JOYRIDESTEP__ = false;
  }

  if (!nextStep) return;
  
  try {
    // --------------------------------------------------
    // 3️⃣ HANDLE ROUTE CHANGE (if needed)
    // --------------------------------------------------
    const needsRouteChange =
      nextStep.route &&
      nextStep.route !== window.location.pathname;

    // --------------------------------------------------
    // ROUTE CHANGE REQUIRED
    // --------------------------------------------------
    if (needsRouteChange && onRouteChange) {
      setRun(false); // ⛔ pause tour

      // 1️⃣ Navigate
      onRouteChange(nextStep.route);

      try {
        // 2️⃣ Wait for page DOM
        await waitForElement(nextStep.target, 20000);

        await new Promise((r) => setTimeout(r, 300));

        if (nextStep.autoOpenKpiButton) {
            
            setRun(false);

            const selector =
              '.static-kpi-card .market-card .kpiOverviewcustomButtonsEnabled button';

            try {
              const kpiButton = await waitForElement(selector, 20000);

              await new Promise((r) => setTimeout(r, 300));

              kpiButton.scrollIntoView({ block: "center" });
              console.log("Button found:", kpiButton);
              console.log("Disabled:", kpiButton.disabled);
              kpiButton.click();

              setStepIndex(nextIndex);
              setRun(true);
            } catch (err) {
              console.error('KPI button not found', err);
            }

            return;
          }

        setStepIndex(nextIndex);
        setRun(true);

      } catch (err) {
        console.error("Joyride route change error:", err);
      }

      return;
    }
   

    if (nextStep.autoOpenKpiButton) {
      
      setRun(false);

      const selector =
        '.static-kpi-card .market-card .kpiOverviewcustomButtonsEnabled button';

      try {
        const kpiButton = await waitForElement(selector, 20000);

        await new Promise((r) => setTimeout(r, 300));

        kpiButton.scrollIntoView({ block: "center" });
        console.log("Button found:", kpiButton);
        console.log("Disabled:", kpiButton.disabled);
        kpiButton.click();

        setStepIndex(nextIndex);
        setRun(true);
      } catch (err) {
        console.error('KPI button not found', err);
      }

      return;
    }

    if (nextStep.highlightSpendCard) {
      setRun(false);

      try {
        //close spend modal on clicking previous from spend modal
        const closeModal = document.querySelector(
        '.modal-header .modal-icon-container .modal-close-btn button'
        );
        if (closeModal) closeModal.click();
        // 1️⃣ Click actual clickable avatar
        // 
        // const avatar = document.querySelector('.clickable-avatar');

        // if (!avatar) throw new Error('Avatar not found');

        // avatar.dispatchEvent(
        //   new MouseEvent('mousedown', { bubbles: true })
        // );
        // avatar.dispatchEvent(
        //   new MouseEvent('mouseup', { bubbles: true })
        // );
        // avatar.dispatchEvent(
        //   new MouseEvent('click', { bubbles: true })
        // );

        // // 2️⃣ Wait until dropdown is mounted
        // const dropdown = await waitForElement('.profile-dropdown');

        // if (!dropdown) throw new Error('Dropdown not created');
        await new Promise((r) => setTimeout(r, 300));
        // 3️⃣ Resume tour
        setStepIndex(nextIndex);
        setRun(true);

      } catch (err) {
        console.error('Profile dropdown failed:', err);
      }

      return;
    }
    if (nextStep.autoOpenProfileSection) {
      setRun(false);

      try {
        
        const avatar = document.querySelector('.clickable-avatar');

        if (!avatar) throw new Error('Avatar not found');
        if(avatar) avatar.click()

        // 2️⃣ Wait until dropdown is mounted
        const dropdown = await waitForElement('.profile-dropdown .profile-menu:not([aria-hidden="true"])', 15000);

        // wait until layout stabilizes
        await new Promise((r) => setTimeout(r, 300));

        if (!dropdown) throw new Error('Dropdown not created');

        // 3️⃣ Resume tour
        setStepIndex(nextIndex);
        setRun(true);

        // const avatar = document.querySelector('.clickable-avatar');
        //   if (avatar) avatar.click();

        //   await waitForElement('.profile-dropdown .profile-menu:not([aria-hidden="true"])', 20000);

        //   setStepIndex(index);
        //   setRun(true);
          // return;

      } catch (err) {
        console.error('Profile dropdown failed:', err);
      }

      return;
    }


    if (nextStep.autoOpenDownloadOptions) {
      setRun(false);
      // 1️⃣ Click header icon
      // const headerIcon = document.querySelector(
      //   '.static-kpi-card .spend-card .kpi-card-header-icons button'
      // );
      // if (headerIcon) headerIcon.click();

      // 2️⃣ Wait for modal
      await waitForElement('.spend-download-btn', 15000);

      // 3️⃣ Click download button
      
      const downloadBtn = document.querySelector('.spend-download-btn');
      if (downloadBtn) downloadBtn.click();

      // 4️⃣ Wait for dropdown
      await waitForElement('.spend-download-btn-options');

      // 5️⃣ IMPORTANT: wait for layout stabilization
      await new Promise((resolve) => setTimeout(resolve, 400));

      // 6️⃣ Force browser reflow (critical trick)
      document.body.getBoundingClientRect();

      // 7️⃣ Now move step
      setStepIndex(nextIndex);
      setRun(true);
      return;
    }

    if (nextStep.highlightKpiSection) {
      setRun(false);
      if (action !== ACTIONS.PREV){
        // 1️⃣ Click header icon
        const headerIcon = document.querySelector(
          '.static-kpi-card .spend-card .kpi-card-header-icons button'
        );
        if (headerIcon) headerIcon.click();
      }

      if (action == ACTIONS.PREV){
        // 1️⃣ Click header icon
        const downloadBtn = document.querySelector('.spend-download-btn');
        if (downloadBtn) downloadBtn.click();
      }
      

      // 2️⃣ Wait for modal
      await waitForElement('.spend-detailpage-kpi-section', 15000);

      // // 5️⃣ IMPORTANT: wait for layout stabilization
      await new Promise((resolve) => setTimeout(resolve, 400));

      window.scrollBy(0, 0);
      // // 6️⃣ Force browser reflow (critical trick)
      document.body.getBoundingClientRect();

      // 7️⃣ Now move step
      setStepIndex(nextIndex);
      setRun(true);
      return;
    }

    // --------------------------------------------------
    // 5️⃣ NORMAL STEP TRANSITION (same page)
    // --------------------------------------------------
    setStepIndex(nextIndex);

  } catch (err) {
    console.error("Joyride step error:", err);
  }
  };

  // ------------------------------------------------
  // Context value
  // ------------------------------------------------
  const contextValue = {
    startTour,     // start from 0 or any step
    stopTour,      // manually stop
    stepIndex,     // current step (optional usage)
    isRunning: run // tour status
  };
  /* istanbul ignore next */
  // const continueOnboarding = async (e) => {
  //   setShowExitWalkme(false);

  //   setTimeout(async() => {
                              
  //     setRun(false);

  //     setTimeout(async() => {
  //       setStepIndex(pendingStep);
  //       setRun(true);
  //     }, 50);

  //   }, 50);
  // }
  /* istanbul ignore next */
  const continueOnboarding = async () => {

  setShowExitWalkme(false);
  setTimeout(async() => {
                              
      setRun(false);

      setTimeout(async() => {
        const step = pendingStep.step;
        const index = pendingStep.index;

        if (step.autoOpenProfileSection) {
          const avatar = document.querySelector('.clickable-avatar');
          if (avatar) avatar.click();

          await waitForElement('.profile-dropdown .profile-menu:not([aria-hidden="true"])', 20000);

          setStepIndex(index);
          setRun(true);
          return;
        }

        if (step.autoOpenKpiButton) {

          const selector = '.static-kpi-card .market-card .kpiOverviewcustomButtonsEnabled button';

          const kpiButton = await waitForElement(selector, 20000);
          kpiButton.click();

          setStepIndex(index);
          setRun(true);
          return;
        }

        if(step.autoOpenDownloadOptions){
          await waitForElement('.spend-download-btn', 15000);

          // 3️⃣ Click download button
          
          // const downloadBtn = document.querySelector('.spend-download-btn');
          // if (downloadBtn) downloadBtn.click();

          // 4️⃣ Wait for dropdown
          await waitForElement('.spend-download-btn-options');

          // 5️⃣ IMPORTANT: wait for layout stabilization
          // await new Promise((resolve) => setTimeout(resolve, 400));

          // // 6️⃣ Force browser reflow (critical trick)
          // document.body.getBoundingClientRect();

          // 7️⃣ Now move step
          setStepIndex(index);
          setRun(true);
        }

        setStepIndex(index);
        setRun(true);
      }, 50);

    }, 50);

  
  };

  return (
    <TourContext.Provider value={contextValue}>
      {
        window.ENV!="PLAYWRIGHT" &&
        <Joyride
        steps={TOUR_STEPS}
        run={run}
        stepIndex={stepIndex}
        className="joyride-react"
        // disableScrollParentFix={true}
        continuous
        // disableBeacon
        disableOverlayClose={true}   // prevents closing on overlay click
        spotlightClicks={true}      
        showSkipButton
        scrollToFirstStep={false}
        // disableScrolling={true}   
        disableScrollParentFix={false}  // prevents layout jump
        scrollOffset={220}  
        tooltipComponent={CustomTooltip}
        callback={handleJoyrideCallback}
        styles={{
          options: { zIndex: 100000, width: 420 },
          overlay: {
            height: "auto"
            // height: "100vh"
          },
          // tooltip: {
          //   width: "420px",
          //   maxWidth: "420px"
          // },
          // options: {
          //   width: 420
          // },
          tooltip: {
            // backgroundColor: "#d42222"
          }
          // overlay: {
          //   pointerEvents: 'auto',
          // }
        }}
        floaterProps={{
          portalElement: document.body,
          // options: { strategy: 'fixed' },
          options: {
            strategy: "absolute"
          }
        }}  
        
        />
      }
      <Modal                   
                      className=""
                      closeOnOutsideClick={false}
                      // hideCloseButton  
                      // onCloseModal={function oFe(){setOpenNotificationModal(false)}}
                      hideCloseButton={true}
                      primaryButtonProps={{
                          onClick: () => {
                            continueOnboarding()
                          },
                      
                      size: 'medium',
                      text: 'Continue onboarding',
                      variant: 'primary'
                      }}
                      onCloseModal={function oFe(){
                         continueOnboarding()
                      }}
                      tertiaryButtonProps={{
                      onClick: function x(){
                        setShowExitWalkme(false)
                        setShowAnimateRocketBtn(!showAnimateRocketBtn)
                        let payload = {
                            "emailId" : userEmailID
                        }                      
                        if(userData?.isWalkMeEnabled){
                            dispatch(CancelWalkmeAccessAction(payload))
                        }
                        
                        sessionStorage.setItem("showLoginAnimation", "true");

                        const closeBtnModal = document.querySelector('.spend-modal .base-button button');
                        if (!closeBtnModal) console.error('closeBtnModal not found');
                        if(closeBtnModal) closeBtnModal.click()
                        
                      },
                      size: 'medium',
                      text: 'Exit onboarding',
                      variant: 'tertiary',
                      className: 'walkme-exit-onboarding'
                      }}
                      showModal={showExitWalkme}
                      showLink={false}
                      showPrimaryButton={true}
                      showSecondaryButton={false}
                      showTertiaryButton={true}
                      showAuxiliaryButton={false}
                      type="S"
                      title="Exit onboarding?"
                  >
                    <div  className="walkme-exit-text">
                           You're about to leave the onboarding before completing all steps.
                           You can return and view the full onboarding experience at any time by clicking the onboarding icon in the top-right corner of the platform.
                    </div>
      </Modal>


      {children}
    </TourContext.Provider>
  );
};
